// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EzVG","left":"styles_left__1B_v9"};